import { InvoiceView } from '.';
import { Company } from './company';
import { Equipment } from './equipment';
import { Extension } from './extension';
import { ExtensionProposal } from './extensionProposal';
import { Invoice } from './invoice';
import { InsuranceStatus } from '~/types/insurance';

// eslint-disable-next-line no-shadow
export enum StatusExtensaoEnum {
  AGUARDANDO_ANALISE = 'Aguardando análise',
  ELEGIVEL_PARA_EXTENSAO = 'Elegível para extensão',
  NAO_ELEGIVEL_PARA_EXTENSAO = 'Não elegível para extensão',
  PROPOSTA_CONFIRMADA = 'Aguardando assinatura',
  TERMO_ASSINADO = 'Termo assinado',
  PROPOSTA_INVALIDA = 'Proposta de extensão inválida',
  PROPOSTA_ENCERRADA_PELO_CLIENTE = 'Solicitação de encerramento',
  PROPOSTA_CANCELADA = 'Proposta cancelada',
  FINALIZADA = 'Proposta finalizada',
  ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA = 'Aguardando revisão',
  NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA = 'Aguardando revisão',
}

// eslint-disable-next-line no-shadow
export enum ContractColorsEnum {
  AGUARDANDO_ANALISE = 'red',
  ELEGIVEL_PARA_EXTENSAO = 'teal',
  NAO_ELEGIVEL_PARA_EXTENSAO = 'twitter',
  PROPOSTA_CONFIRMADA = 'purple',
  TERMO_ASSINADO = 'green',
  PROPOSTA_INVALIDA = 'cyan',
  PROPOSTA_ENCERRADA_PELO_CLIENTE = 'blackAlpha',
  PROPOSTA_CANCELADA = 'facebook',
  FINALIZADA = 'linkedin',
  ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA = 'orange',
  NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA = 'orange',
}

export interface Contract {
  id_contrato: string;
  nu_contrato: string;
  ds_rotaminutacontrato: string;
  dt_inicialcontrato: string;
  nu_mesescontrato: string;
  prazo_contrato: string;
  vr_totalinicialcontrato: string;
  vr_totalmensalcontrato: string;
  vr_mensal_atual: string;
  dd_ajusteinflacao: string;
  mm_ajusteinflacao: string;
  tp_consolidacaofatura: string;
  tp_situacao: string;
  dh_ultimaatualizacao: string;
  id_indicecorrecao: number;
  ds_observacao: string;
  dt_encerramentocontrato: string;
  mes_encerramentocontrato: string;
  nm_indicecorrecao: string;
  nu_pedido: string;
  empresas: Company;
  extensoes: Extension[];
  faturas: Invoice[];
  equipamentos: Equipment[];
  contratos_relacionados: Contract[];
  formattedEquipments: SummarizedEquipments[];
  qtd_equipamentos: number;
  vr_totalcontrato: string;
  status_pgto: string;
  st_faturamento: number | string;
  status_proposta: number;
  precisa_termo_extensao: boolean;
  proposta_extensao?: ExtensionProposal;
  vencimento_final?: string;
  pode_analisar_extensao: boolean;
  pode_estender_contrato: boolean;
  possui_faturas_atraso: boolean;
  possui_termo_extensao: boolean;
  locador: string;
  pode_cancelar_extensao: boolean;
  nu_termo_segue_padrao: boolean;
  nu_termo_sugerido: string;
  apolice?: InsuranceStatus;
  certificado_zero_carbono: number;
  selecionado?: boolean;
  desabilitado?: boolean;
  anotacao1?: string;
  anotacao2?: string;
}

export interface ContractForDocuments {
  id_contrato: string;
  nu_contrato: string;
}

export interface SummarizedEquipments {
  id_equipamento: number;
  cd_equipamento: string;
  nm_tipoequipamento: string;
  nm_modeloequipamento: string;
  ds_equipamento: string;
  quantity: number;
  segurado: boolean;
  nu_series: string[] | null;
  nu_series_vigentes: { nu_serie: string; id_contratoequipamento: number }[];
  nu_series_devolvidos: { nu_serie: string; id_contratoequipamento: number }[];
  selecionado: boolean;
  apolice: number;
}

export interface ContractView extends Contract {
  formattedInitialValue: string;
  formattedMensalValue: string;
  formattedMensalAtualValue: string;
  formattedInitialDate: string;
  formattedEndDate: string;
  formattedDueDate: string;
  formattedVencimentoFinal?: string;
  /* 
  formattedStatus: string;
  status: number; 
  */
  colorScheme: string;
  quantity: number;
  formattedMonth: string;
  empresas: Company;
  extensoes: Extension[];
  faturas: InvoiceView[];
  equipamentos: Equipment[];
  contratos_relacionados: ContractRelatedView[];
  formattedTotalValue: string;
  status_pgto: string;
  stFaturamentoDesc: string;
  formattedStatus: StatusExtensaoEnum;
  statusColorScheme: string;
  formattedTipoSituacao: string;
  colorSchemeTipoSituacao: string;
  formattedSituacaoFaturamento: string;
  colorSchemeSituacaoFaturamento: string;
  possui_certificado_projeto_zero_carbono?: boolean;
  possui_projeto_zero_carbono?: boolean;
  pode_rescisao?: boolean;
}

export interface ContractRelatedView extends Contract {
  formattedVencimentoFinal?: string;
  formattedTotalValue: string;
}

export interface InformacoesComerciais {
  comissionado: Comissionado;
  faturas: Fatura[];
}

export interface Comissionado {
  codigo_sap: string;
  nome: string;
  quantidade_parcelas: number;
  valor: number;
  tipo: string;
}

export interface Fatura {
  cd_fatura: string;
  valor_comissao: number;
  percentual_de_comissao: number;
}

// eslint-disable-next-line no-shadow
export enum StatusExtensaoIdEnum {
  AGUARDANDO_ANALISE_EXTENSAO,
  ELEGIVEL_EXTENSAO,
  NAO_ELEGIVEL_EXTENSAO,
  AGUARDANDO_ASSINATURA,
  TERMO_ASSINADO,
  PROPOSTA_INVALIDA,
  PROPOSTA_ENCERRADA_PELO_CLIENTE,
  PROPOSTA_CANCELADA,
  FINALIZADA,
  ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA,
  NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA,
}

// eslint-disable-next-line no-shadow
export enum StatusApoliceEquipamentoEnum {
  NAO_POSSUI,
  A_VENCER_OU_VIGENTE,
  ENCERRADAS,
}

export interface Feature {
  contrato_analise_automatica: number;
  feature: number;
  id: number;
  label: string;
  limiar: number;
  operador: number;
  operador_label: string;
  relevancia: number;
  valor: number;
  resultado: boolean;
  formattedValue: string;
  formattedLimit: string;
  signal: string;
  description: string;
}

export interface AutomaticAnalysis {
  nu_contrato: string;
  contrato: number;
  data_analise: string;
  features: Feature[];
  most_relevant_features: string;
  validFeaturesCount: number;
  id: number;
  motivo: string;
  resultado: number;
}
